const capitalizeStatesInLocation = (location?: string): string => {
  if (!location) {
    return ''
  }
  // This regex looks for:
  // (?:, ): a non-capturing group for ", "
  // ([a-z]{2}): a capturing group for exactly two lowercase letters
  // $: asserts position at the end of the string
  const regex = /(?:, )([a-z]{2})$/
  return location.replace(regex, (match, p1) => {
    // match is the entire matched string (e.g., ", pa")
    // p1 is the first captured group (e.g., "pa")
    return `, ${p1.toUpperCase()}`
  })
}

export default capitalizeStatesInLocation
